import { isEqual } from 'lodash';
import { memo } from 'react';

import { PrivateGalleryBoard, type PrivateGalleryBoardProps } from './PrivateGalleryBoard';
import { PrivateGalleryBoardAncestors } from './PrivateGalleryBoardAncestors';

type LibraryGalleryBoardProps = Omit<PrivateGalleryBoardProps, 'trackLocation'>;

export const AllContentGalleryBoard = memo(({ index, box, data }: LibraryGalleryBoardProps) => {
  return (
    <PrivateGalleryBoard
      index={index}
      box={box}
      data={data}
      ancestors={<PrivateGalleryBoardAncestors libraryTitle={data.library?.title} ancestors={data.ancestors} />}
    />
  );
}, isEqual);

AllContentGalleryBoard.displayName = 'LibraryGalleryBoard';
